import React from 'react';
import ModelsGalleryPage from '../components/models-gallery/ModelsGalleryPage';

const ModelsGalleryPageWrapper: React.FC = () => {
  return <ModelsGalleryPage />;
};

export default ModelsGalleryPageWrapper;